import styled from "styled-components";

export const CommentWrapper = styled.div<{ $fromNotification?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  .name {
    font-weight: bold;
    margin-right: 8px;
  }

  .name-and-comment-container {
    margin-left: 12px;
    flex: 1;
  }

  .comment-timestamp {
    font-size: 12px;
    color: #999;
    font-weight: 400;
    white-space: nowrap;
  }

  .comment-header-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding-bottom: 6px;
  }

  .comment-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }

  .action-btn {
    background: #f8f9fb;
    border: 1px solid #e5e7eb;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 999px;
    transition: all 0.2s ease;
  }

  .icon-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-height: 28px;
  }

  .action-btn:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  }

  .action-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .action-btn.edit,
  .action-btn.save {
    color: #007bff;
    border-color: #dbeafe;
    background: #eff6ff;
  }

  .action-btn.cancel {
    color: #666;
    border-color: #e5e7eb;
    background: #f9fafb;
  }

  .action-btn.delete {
    color: #d33;
    border-color: #fecaca;
    background: #fef2f2;
  }

  .comment-edit-textarea {
    width: 100%;
    min-height: 70px;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 8px;
    resize: vertical;
    font-size: 14px;
    outline: none;
  }

  border: 1px solid #eee;
  ${(props) => props.$fromNotification && `border: 2px solid orange;`}
  height: auto;
  padding: 18px;
  border-radius: 25px;
  margin-bottom: 12px;
  &:last-child {
    margin-bottom: 0;
  }
  word-break: break-all;
  overflow-wrap: break-word;
  max-width: 100%;
`; 

export const ProfilePicture = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;

  img {
    width: 100%;
    object-fit: contain;
  }
`;
